import { get, post, put, del } from "../request";

const PREFIX = "/education-member-admin/messageCenterAdmin";

/** 分页查询消息列表 */
export function getMessageList(params) {
  return get(`${PREFIX}/list`, params);
}

/** 查询消息详情 */
export function getMessageDetail(messageCenterId) {
  return get(`${PREFIX}/${messageCenterId}`);
}

/** 新增消息 */
export function addMessage(data) {
  return post(PREFIX, data);
}

/** 修改消息 */
export function updateMessage(data) {
  return put(PREFIX, data);
}

/** 删除消息 */
export function deleteMessage(messageCenterId) {
  return del(`${PREFIX}/${messageCenterId}`);
}

/** 立即发送消息 */
export function sendMessage(messageCenterId) {
  return post(`${PREFIX}/${messageCenterId}/send`);
}

/** 重复发送消息 */
export function repeatMessage(messageCenterId) {
  return post(`${PREFIX}/${messageCenterId}/repeat`);
}

/** 导出消息 */
export function exportMessage(params) {
  return get(`${PREFIX}/export`, params);
}



// WEBPACK FOOTER //
// ./src/api/message/index.js